import React from 'react';

import * as S from './styles';

const Line = () => {
  return <S.Line />;
};

export default Line;
